import styled from 'styled-components'

export default styled.p`
  font-family: everett-regular, system-ui, sans-serif;
  font-size: 1.8vw;
  line-height: 150%;
  color: #212121;

  @media  (max-width: 48em) {
    font-size: 18px;
  }

  @media (min-width: 48em) and (max-width: 60em) {
    font-size: 18px;
  }
`
